import TableTabs from '../../../../../components/ListV2/components/tabs/TableTabs';
import { CatalogListTabType } from '../utils/catalogListTabs/catalogListTabType.enum';
import {
  CatalogListTab,
  CatalogListTabCounts,
} from '../utils/catalogListTabs/catalogListTabs.types';

interface CatalogListTabsProps {
  visibleTabs: CatalogListTab[];
  selectedTab: CatalogListTabType;
  tabCounts: CatalogListTabCounts;
  totalCount: number;
  isLoading?: boolean;
  onChangeTab: (tab: CatalogListTab) => void;
}

const CatalogListTabs = ({
  visibleTabs,
  selectedTab,
  tabCounts,
  totalCount,
  isLoading,
  onChangeTab,
}: CatalogListTabsProps) => {
  const resolveTabCount = (tab: CatalogListTab): number | undefined => {
    const count = tabCounts[tab.name];

    if (tab.name === CatalogListTabType.ALL) {
      return count ?? totalCount;
    }

    return count;
  };

  const tabs = visibleTabs.map((tab): CatalogListTab => {
    const count = resolveTabCount(tab);

    if (count === undefined) {
      return tab;
    }

    return { ...tab, subTitle: String(count) };
  });

  return (
    <TableTabs<CatalogListTab>
      tabs={tabs}
      onClick={onChangeTab}
      isLoading={isLoading}
      selected={selectedTab}
    />
  );
};

export default CatalogListTabs;
